import translationEn from './en/transcription.json'

export const resources = {
    en: {
        translation: translationEn
    }
};